const currencyLocaleMap: Record<string, string> = {
  GBP: "en-GB",
  USD: "en-US",
  EUR: "de-DE",
  INR: "en-IN",
};

export const formatCurrency = (amount: number, currency: string = "GBP") => {
  const locale = currencyLocaleMap[currency] || "en-GB";

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
  }).format(amount);
};
